'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:webview:open');
}

var _invoke = require('../invoke');

/**
 * 打开新页面
 *
 * 与 `hbnb.webivew.close` 配合使用
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof webview
 * @static
 * @name open
 * @param {String} url 页面地址
 * @return {Undefined}
 * @example
 *  hbnb.webview.open('http://i.meituan.com');
 */
module.exports = function(url) {
    if (process.env.NODE_ENV !== 'production') {
        debug('url is %s', url);
    }

    _invoke('webview', 'open', {
        url: url
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/webview/open.js
// module id = 663
// module chunks = 0